import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LiveTrainingSession} from 'src/app/backend/elearning-api/learning-paths/get-learning-paths.response';
import {TrainingLock, TrainingLockReason} from 'src/app/features/e-learning/learningpath/learningpath.component';

@Component({
  selector: 'app-livetraining-card',
  templateUrl: './livetraining-card.component.html',
  styleUrls: ['./livetraining-card.component.scss'],
})
export class LivetrainingCardComponent implements OnInit {
  @Input() liveTraining?: LiveTrainingSession;
  @Input() isLocked?: TrainingLock | null;
  expanded = false;
  startDate?: Date;
  endDate?: Date;

  constructor(private readonly _translate: TranslateService) {}

  ngOnInit(): void {
    if (this.liveTraining?.starts_at && this.liveTraining?.ends_at) {
      this.startDate = new Date(this.liveTraining.starts_at);
      this.endDate = new Date(this.liveTraining.ends_at);
    }
  }

  toggleExpansion() {
    this.expanded = !this.expanded;
  }

  getMonth() {
    return this.startDate?.toLocaleDateString(this._translate.currentLang, {month: 'short'}) ?? '--';
  }

  getStartTime() {
    return this.startDate?.toLocaleTimeString(this._translate.currentLang, {hour: '2-digit', minute: '2-digit'}) ?? '--';
  }

  getEndTime() {
    return this.endDate?.toLocaleTimeString(this._translate.currentLang, {hour: '2-digit', minute: '2-digit'}) ?? '--';
  }

  getDay() {
    if (!this.startDate) return '--';

    const day = this.startDate.getDate();
    const lang = this._translate.currentLang;

    if (lang === 'de') {
      return `${day}.`;
    } else if (lang === 'en') {
      const suffix = this.getOrdinalSuffix(day);
      return `${day}${suffix}`;
    }

    return day.toString();
  }

  private getOrdinalSuffix(day: number): string {
    const v = day % 100;
    if (v >= 11 && v <= 13) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  getLockReason() {
    if (this.isLocked) {
      if (this.isLocked.reason === TrainingLockReason.OVER) {
        return 'done';
      }
      return 'undecided';
    }
  }

  getLockReasonTooltip() {
    if (this.isLocked) {
      return this._translate.instant(`LTS.LOCKED.${this.isLocked.reason}`);
    }
  }

  getIcsFile() {
    if (this.liveTraining?.ics_file) {
      return `data:text/calendar;base64,${btoa(this.liveTraining.ics_file)}`;
    }
    // for the pipe to be happy, can't occurr if correctly fetched in template
    return '';
  }
}
